import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { ServiceCategoriesResponse } from "@/api/types";

export function useServiceCategories() {
  return useQuery({
    queryKey: ["service_categories"],
    queryFn: () =>
      api
        .get("service_categories", { searchParams: { with_businesses: "true" } })
        .json<ServiceCategoriesResponse>(),
    staleTime: 3_600_000,
  });
}
